import { IUserGoal } from '@common/Goals/utils/types'
import { FC } from 'react'
import cn from './index.module.css'
import { DeleteOutlined } from '@ant-design/icons'

interface IGoalCard {
  goal: IUserGoal
  onClick: () => void
  onRemove: () => void
}

const GoalCard: FC<IGoalCard> = ({ goal, onClick, onRemove }) => {
  return (
    <div className={cn.wrapper}>
      <div className={cn.title} onClick={onClick}>
        {goal.title}
      </div>
      <button className={cn.removeButton} onClick={onRemove}>
        <DeleteOutlined
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </button>
    </div>
  )
}

export default GoalCard
